var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50005 15.075V11.625L2.92505 13.525C3.65005 14.2 4.52505 14.725 5.50005 15.075Z",
    fill: "#2A5F9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.075C11.475 14.725 12.35 14.2 13.075 13.525L10.5 11.6V15.075Z",
    fill: "#2A5F9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.925049 10.5C1.00005 10.75 1.10005 10.975 1.22505 11.225L2.20005 10.5H0.925049Z",
    fill: "#2A5F9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 10.5L14.775 11.225C14.875 11 14.975 10.75 15.075 10.5H13.8Z",
    fill: "#2A5F9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87502 9.5H0.650024C0.725024 9.85 0.825024 10.175 0.925024 10.5H2.20002L1.22502 11.225C1.42502 11.65 1.65002 12.025 1.92502 12.4L4.50002 10.5H5.50002V11L2.57502 13.15L2.92502 13.5L5.50002 11.625V15.075C5.82502 15.2 6.15002 15.275 6.50002 15.35V9.5H5.87502Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 9.5H9.5V15.35C9.85 15.275 10.175 15.175 10.5 15.075V11.625L13.075 13.5C13.425 13.175 13.725 12.825 14.025 12.45L11.35 10.5H13.05L14.575 11.625C14.65 11.5 14.725 11.35 14.775 11.225L13.8 10.5H15.075C15.175 10.175 15.275 9.85 15.35 9.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92505 12.4C2.12505 12.675 2.32505 12.925 2.55005 13.175L5.50005 11.025V10.525H4.50005L1.92505 12.4Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 10.5L14.05 12.45C14.15 12.325 14.225 12.2 14.325 12.075C14.35 12.05 14.35 12.025 14.375 12.025C14.45 11.9 14.55 11.75 14.625 11.625L13.05 10.5H11.375Z",
    fill: "#ED4C5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.925003V4.375L13.075 2.475C12.35 1.8 11.475 1.275 10.5 0.925003Z",
    fill: "#2A5F9E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50005 0.925003C4.52505 1.275 3.65005 1.8 2.92505 2.475L5.50005 4.4V0.925003Z",
    fill: "#2A5F9E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 5.50001C15 5.25001 14.9 5.02501 14.775 4.77501L13.8 5.50001H15.075Z",
    fill: "#2A5F9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20005 5.50001L1.22505 4.77501C1.12505 5.02501 1.02505 5.25001 0.925049 5.50001H2.20005Z",
    fill: "#2A5F9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6.49999H15.325C15.25 6.14999 15.15 5.82499 15.05 5.49999H13.775L14.75 4.77499C14.55 4.34999 14.325 3.97499 14.05 3.59999L11.5 5.49999H10.5V4.99999L13.425 2.84999L13.075 2.49999L10.5 4.37499V0.924994C10.175 0.799994 9.85 0.724994 9.5 0.649994V6.49999H10.125Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.650024 6.49999H6.50002V0.649994C6.15002 0.724994 5.82502 0.824994 5.50002 0.924994V4.37499L2.92502 2.49999C2.57502 2.82499 2.27502 3.17499 1.97502 3.54999L4.65002 5.49999H2.95002L1.42502 4.37499C1.35002 4.49999 1.27502 4.64999 1.22502 4.77499L2.20002 5.49999H0.925024C0.825024 5.82499 0.725024 6.14999 0.650024 6.49999Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.075 3.6C13.875 3.325 13.675 3.075 13.45 2.825L10.5 4.975V5.475H11.5L14.075 3.6Z",
    fill: "#ED4C5C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62502 5.5L1.97502 3.55C1.87502 3.675 1.80002 3.8 1.70002 3.925C1.67502 3.95 1.67502 3.975 1.65002 3.975C1.57502 4.1 1.47502 4.25 1.40002 4.375L2.92502 5.5H4.62502Z",
    fill: "#ED4C5C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 6.5H9.5V0.65C9.025 0.55 8.525 0.5 8 0.5C7.475 0.5 6.975 0.55 6.5 0.65V6.5H0.65C0.55 6.975 0.5 7.475 0.5 8C0.5 8.525 0.55 9.025 0.65 9.5H6.5V15.35C6.975 15.45 7.475 15.5 8 15.5C8.525 15.5 9.025 15.45 9.5 15.35V9.5H15.35C15.45 9.025 15.5 8.525 15.5 8C15.5 7.475 15.45 6.975 15.35 6.5Z",
    fill: "#ED4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.c2c0019f95b8dc29e7e5066520786fcb.svg";
export { ForwardRef as ReactComponent };